import { render, staticRenderFns } from "./CustomizeYourKit.vue?vue&type=template&id=65428e12&scoped=true&lang=pug&"
import script from "./CustomizeYourKit.vue?vue&type=script&lang=js&"
export * from "./CustomizeYourKit.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeYourKit.vue?vue&type=style&index=0&id=65428e12&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65428e12",
  null
  
)

export default component.exports